'use client';

import React from 'react';
import { Check, Circle } from 'lucide-react';
import type { PublicRecord } from '@/types/publicRecords';
import { buildReviewTrail } from '@/lib/recordTrust';
import type { PageTokens } from '@/lib/dashboardTheme';

type Props = {
  record: PublicRecord;
  th?: PageTokens;
  compact?: boolean;
};

export default function RecordReviewTrail({ record, th, compact = false }: Props) {
  const steps = buildReviewTrail(record);
  const text = th?.textSecondary ?? '#475569';
  const muted = th?.textMuted ?? '#94a3b8';
  const divider = th?.divider ?? 'rgba(148,163,184,0.25)';

  return (
    <div>
      <div
        style={{
          fontSize: compact ? 9 : 10,
          fontWeight: 700,
          color: muted,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          marginBottom: compact ? 8 : 10,
        }}
      >
        Review trail
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: compact ? 6 : 8 }}>
        {steps.map((step) => (
          <div
            key={step.id}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
              paddingBottom: compact ? 6 : 8,
              borderBottom: `1px solid ${divider}`,
            }}
          >
            <span
              style={{
                marginTop: 2,
                flexShrink: 0,
                color: step.completed ? '#10b981' : muted,
              }}
            >
              {step.completed ? <Check size={14} /> : <Circle size={14} />}
            </span>
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontSize: compact ? 11 : 12,
                  fontWeight: step.completed ? 600 : 500,
                  color: step.completed ? text : muted,
                }}
              >
                {step.label}
              </div>
              {step.detail && (
                <div style={{ fontSize: 10, color: muted, marginTop: 2 }}>{step.detail}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
